import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { FaMinus, FaPlus } from 'react-icons/fa';

import { CheckboxField } from 'Shared/form/CheckboxField';
import { TextField } from 'Shared/form/TextField';
import withFormikFields, { fieldHelpersPropType } from 'Shared/form/withFormikFields';
import CommonPatientFieldWrapper from './CommonPatientFieldWrapper';
import SectionTitleStyle from './SectionTitleStyle';

const AllergiesForm = ({
    fieldValues: { noKnownAllergies, otherAllergy },
    fieldHelpers: {
        otherAllergy: { setValue },
    },
}) => {
    return (
        <CommonPatientFieldWrapper fieldName="allergies">
            {(commonProps) => (
                <div>
                    <SectionTitleStyle>
                        <h2>Allergies</h2>
                    </SectionTitleStyle>

                    <CheckboxField
                        fieldName="noKnownAllergies"
                        label="No known allergies"
                        disabled={commonProps.disabled}
                    />

                    {!noKnownAllergies && (
                        <>
                            <TextField {...commonProps} fieldName="allergy" label="Allergy" placeholder="Add Allergy" />

                            {otherAllergy.map((allergy, index) => (
                                <TextField
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={index}
                                    {...commonProps}
                                    fieldName={`otherAllergy[${index}]`}
                                    label="Allergy"
                                    placeholder="Add Allergy"
                                    addonButton={
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => {
                                                const newOtherAllergy = [...otherAllergy];
                                                newOtherAllergy.splice(index, 1);
                                                setValue(newOtherAllergy);
                                            }}
                                            aria-label="Remove Allergy"
                                        >
                                            <FaMinus />
                                        </Button>
                                    }
                                />
                            ))}

                            {!commonProps.disabled && (
                                <Button
                                    variant="link"
                                    onClick={() => {
                                        setValue([...otherAllergy, '']);
                                    }}
                                >
                                    <FaPlus /> Add Allergy
                                </Button>
                            )}
                        </>
                    )}
                </div>
            )}
        </CommonPatientFieldWrapper>
    );
};

AllergiesForm.propTypes = {
    fieldValues: PropTypes.shape({
        noKnownAllergies: PropTypes.bool,
        otherAllergy: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
    fieldHelpers: fieldHelpersPropType.isRequired,
};

export default withFormikFields({ WrappedComponent: AllergiesForm, fieldNames: ['noKnownAllergies', 'otherAllergy'] });
